import { useEffect } from "react";

import { useVerifyUserInviteEmailQuery } from "@/redux/service";
import { AdminRegisterFormValues } from "../types";
import { adminInviteRegisterSchema } from "../utils/formValidation";
import {
  adminInviteRegisterDefaultValues,
  buildAdminInviteResetValues,
} from "../utils/formInitialValues";
import { useRegisterForm } from "./useRegisterForm";

export const useAdminInviteRegisterForm = () => {
  const result = useRegisterForm<AdminRegisterFormValues>({
    useVerifyToken: useVerifyUserInviteEmailQuery,
    schema: adminInviteRegisterSchema,
    defaultValues: adminInviteRegisterDefaultValues,
    buildResetValues: buildAdminInviteResetValues,
  });

  const { form } = result;
  const phoneNumber = form.watch("organization.phoneNumber");

  useEffect(() => {
    if (!phoneNumber) return;

    const sanitized = phoneNumber.replace(/[^\d+\s]/g, "");
    if (sanitized === "") {
      form.setValue("organization.phoneNumber", "+");
    } else if (!sanitized.startsWith("+")) {
      form.setValue("organization.phoneNumber", "+" + sanitized);
    } else if (sanitized !== phoneNumber) {
      form.setValue("organization.phoneNumber", sanitized);
    }
  }, [phoneNumber, form]);

  return result;
};
